import { render, staticRenderFns } from "./VisitPatientList.vue?vue&type=template&id=4266cbac&"
import script from "./VisitPatientList.vue?vue&type=script&lang=ts&"
export * from "./VisitPatientList.vue?vue&type=script&lang=ts&"
import style0 from "./VisitPatientList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports